<div fxLayout="column" fxFlex="100" style="width: 600px;">

    <div fxLayout="row" class="wizard-row">
        <div fxLayout="column">
            <h3>1. Συμπληρώστε τα στοιχεία σας ως χρήστης</h3>
            <h5>2. Θα πρέπει να ολοκληρώσετε τη διαδικασία κωδικού 2 βημάτων για το κινητό και το email σας</h5>

        </div>
    </div>

    <div fxLayout="row" fxFlex="grow">

        <form [formGroup]="parentFormGroup" fxLayoutGap="10px" fxFlex="100">
            <div fxLayout="column" fxFlex="48">
                <mat-form-field appearance="legacy" >
                    <mat-label>Όνομα</mat-label>
                    <input matInput formControlName="first_name" tabindex="1">
                </mat-form-field>

                <mat-form-field appearance="legacy" >
                    <mat-label>Επώνυμο</mat-label>
                    <input matInput formControlName="last_name" tabindex="2">
                </mat-form-field>

                <mat-form-field appearance="legacy" >
                    <mat-label>Τηλέφωνο</mat-label>
                    <input matInput formControlName="telephone" tabindex="3" type="number">
                    <button *ngIf="parentFormGroup.controls.telephone.value && !isTelephoneCodeValid()" matSuffix mat-icon-button aria-label="Send" (click)="sendMobileOTP()">
                        <mat-icon>sms</mat-icon>
                    </button>

                    <button matSuffix mat-icon-button *ngIf="isTelephoneCodeValid()">
                        <mat-icon style="color: green;">done</mat-icon>
                    </button>
                </mat-form-field>

                <mat-form-field appearance="legacy" >
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" tabindex="4">
                    <button *ngIf="parentFormGroup.controls.email.value && !isEmailCodeValid()" matSuffix mat-icon-button aria-label="Send" (click)="sendEmailOTP()">
                        <mat-icon>sms</mat-icon>
                    </button>

                    <button matSuffix mat-icon-button *ngIf="isEmailCodeValid()">
                        <mat-icon style="color: green;">done</mat-icon>
                    </button>
                </mat-form-field>

                <mat-form-field appearance="legacy" >
                    <mat-label>Πατέρας / Μητέρα</mat-label>
                    <mat-select formControlName="parentType" tabindex="5">
                        <mat-option value="1">Πατέρας</mat-option>
                        <mat-option value="2">Μητέρα</mat-option>
                    </mat-select>
                    <!--                    <input matInput [(ngModel)]="confirmPassword">-->
                </mat-form-field>

                <mat-form-field appearance="legacy">
                    <mat-label>Κωδικός</mat-label>
                    <input matInput formControlName="password" type="password" tabindex="6">
                </mat-form-field>

            </div>

            <div fxLayout="column" fxFlex="48">
                <div fxFlex="33"></div>

                <mat-form-field appearance="legacy" >
                    <mat-label>OTP Τηλεφώνου</mat-label>
                    <input matInput formControlName="telephoneOTP" [readonly]="isTelephoneCodeValid()" [disabled]="isTelephoneCodeValid()">
                  <button *ngIf="parentFormGroup.controls.telephoneOTP.value" matSuffix mat-icon-button aria-label="Send" (click)="verifyMobileCode()">
                    <mat-icon>sms</mat-icon>
                  </button>
                </mat-form-field>

                <mat-form-field appearance="legacy" >
                    <mat-label>OTP Email</mat-label>
                    <input matInput formControlName="emailOTP" [readonly]="isEmailCodeValid()" [disabled]="isEmailCodeValid()">

                  <button *ngIf="parentFormGroup.controls.emailOTP.value" matSuffix mat-icon-button aria-label="Send" (click)="verifyEmailCode()">
                    <mat-icon>sms</mat-icon>
                  </button>
                </mat-form-field>

            </div>
        </form>
    </div>

    <div fxLayout="row" class="wizard-row">
        <h5>3. Θα συνδεέστε στο eApply με το email και το κωδικό που έχετε εισάγει σε αυτή τη φόρμα</h5>
    </div>
</div>
